import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, Switch, Select, Badge } from 'antd';

import { categoryColors } from './../../utils/color-utils';

const EditCategoryModal = ({ rootContainer, isOpen, title, categoryToEdit, categoriesLoading, handleModalOk, handleModalCancel }) => {
  const [form] = Form.useForm();

  const colors = categoryColors;

  useEffect(() => {
    if (isOpen && categoryToEdit) {
      form.setFieldsValue({
        categoryName: categoryToEdit.categoryName,
        color: categoryToEdit.color,
        displayByDefault: categoryToEdit.displayByDefault,
        sendEmails: categoryToEdit.sendEmails,
      });
    }
  }, [isOpen, categoryToEdit]);

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        const category = {
          id: categoryToEdit && categoryToEdit.id ? categoryToEdit.id : null,
          settingId: categoryToEdit && categoryToEdit.settingId ? categoryToEdit.settingId : null,

          categoryName: values.categoryName,
          color: values.color,
          displayByDefault: values.displayByDefault,
          sendEmails: values.sendEmails,
        };

        handleModalOk(category).then(() => {
          form.resetFields();
        });
      })
      .catch((errorInfo) => {});
  };

  const handleCancel = () => {
    form.resetFields();

    handleModalCancel();
  };

  return (
    <Modal
      id="calendar-category-edit-modal"
      title={title}
      getContainer={rootContainer}
      open={isOpen}
      width={500}
      onOk={handleOk}
      confirmLoading={categoriesLoading}
      onCancel={handleCancel}
      destroyOnClose={true}
      maskClosable={false}
      closable={false}
    >
      <Form
        form={form}
        name="category-form"
        labelCol={{ span: 7 }}
        wrapperCol={{ span: 17 }}
        initialValues={{ remember: true }}
        scrollToFirstError={true}
        requiredMark={false}
        autoComplete="off"
      >
        <Form.Item label="Name" name="categoryName" rules={[{ required: true, message: 'Required' }]}>
          <Input placeholder="Please enter category name" />
        </Form.Item>

        {colors && (
          <Form.Item label="Current color" name="color" initialValue={null}>
            <Select allowClear getPopupContainer={rootContainer} placeholder="Choose background color">
              {colors &&
                colors.map((item) => (
                  <Select.Option key={item.value} value={item.value}>
                    <Badge size="default" color={item.value} /> {item.name}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
        )}

        <Form.Item label="Checked by default" name="displayByDefault" valuePropName="checked">
          <Switch />
        </Form.Item>

        <Form.Item label="Send emails" name="sendEmails" valuePropName="checked">
          <Switch />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditCategoryModal;
